import {AbstractSearchCriteria} from './abstract-search-criteria';

export class BoardBasisSetupSearchCriteria extends AbstractSearchCriteria {
    code: string;
    name: string;
    createdOn: Date;
}
